export function createGenericQueryString(params) {
    return ('?' +
        Object.keys(params)
            .map((key) => {
            return `${key}=${Array.isArray(params[key]) ? params[key].join(',') : params[key]}`;
        })
            .join('&'));
}
